import { render, staticRenderFns } from "./CryptoCom.vue?vue&type=template&id=63786332&"
import script from "./CryptoCom.vue?vue&type=script&lang=ts&"
export * from "./CryptoCom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports